import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import user from './module/user'
import records from './module/records'
import consume from './module/consume'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        rechargeChannels: [],
        showLoginPopup: false,
        showRegisterPopup: false,
        loginPath: '',
        totalEg: '...'
    },
    mutations,
    modules: {
        user,
        records,
        consume
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js